export default __webpack_public_path__ + "static/media/Belt of the Farseeker.5f058756.jpg";